var isSafari = function isSafari() {
  var WIN = window;
  return /constructor/i.test(WIN.HTMLElement) || function (p) {
    return p.toString() === '[object SafariRemoteNotification]';
  }(!WIN.safari || typeof WIN.safari !== 'undefined' && WIN.safari.pushNotification);
};

export { isSafari };